export const config = {
    'API_BFF_TITASK_APP': 'https://bff-app-titask.dev.titask.com/bff-app-titask/v1',
    'API_INTEGRATIONS_URI': 'https://integraciones-labs-v2.kit23.com/api/integrations/v1',
    'API_INTEGRATIONS_TOKEN': '6HrfHg8Z2TT9wT9FKQu4',
    'API_INTEGRACIONES_COMUNIDADTASK_URI': 'https://integraciones.comunidadtask.cl'
};
